export const layoutVariables = () => ({});
